import { PulseLoader } from "react-spinners";
import "./style.css";

function Loader(loading) {
  return (
    <div id="custom-pulse-loader">
      <PulseLoader
        margin={7}
        color={"#9ab497"}
        loading={loading}
        size={15}
      />
    </div>
  );
}
export default Loader;
